import Logger from "../core/util/Logger";


export const resetReduxStoreAction = (action) => async dispatch => {

    Logger.info("request to execute action [" + action + "] on redux store ");
    dispatch({type: action});
};